import { getId } from "./util.js";

let parser = new DOMParser();
let svgArray = [];

// fetch('assets/images/storeSvg.svg')
//   .then(r => r.text())
//   .then(text => {
//     let doc = parser.parseFromString(text, "text/html");
//     let svgStore = doc.getElementsByTagName('svg');
//     svgArray = Array.from(svgStore);
//     updateUse(document);
//   })

Promise.all([
  fetch('assets/images/storeSvg.svg'),
  fetch('assets/images/sweatySvg.svg')
]).then((promises) => {
  promises.forEach(promise => {
    let text = promise.text().then(text => {
      let doc = parser.parseFromString(text, "text/html");
      let svgStore = doc.getElementsByTagName('svg');
      Array.from(svgStore).forEach(el => {
        svgArray.push(el);
      });
      updateUse(document);
    });
  });
});

export function updateUse(container, extraStyles) {
  let useElement = [...container.getElementsByClassName("use")];

  useElement.forEach((element) => {
    let useId = element.id.replace("-icon", "") + "-source";
    let iconSrc;
    iconSrc = svgArray.find((element) => element.id == useId).cloneNode(true);
    iconSrc.id = useId.replace("-source", "-insert");
    element.parentNode.insertBefore(iconSrc, element);
    element.remove();
  });
}